import { Container, Row, Col } from "react-bootstrap";

const LoginDesktop = ({ handleSubmit, email, setEmail, status }) => {
    const inputStyle = {
        width: "100%",
        height: "50px",
        border: "2px solid #e2e8f0",
        outline: "none",
        color: "#1a1a2e",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        paddingLeft: "16px",
        paddingRight: "16px",
        fontSize: "1rem",
        transition: "border-color 0.2s, box-shadow 0.2s"
    };

    return (
        <>
            {/* Dark Header */}
            <div style={{
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                padding: '100px 0 4rem'
            }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={6} lg={6} className="text-center">
                            <h1 style={{
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '2.25rem',
                                marginBottom: '0.75rem'
                            }}>
                                Welcome Back
                            </h1>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '1.1rem',
                                margin: 0
                            }}>
                                Sign in to access your Spawnry dashboard
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Login Form */}
            <Container style={{ marginTop: '-2rem', paddingBottom: '3rem' }}>
                <Row className="justify-content-center">
                    <Col md={6} lg={6}>
                        <div style={{
                            background: 'white',
                            borderRadius: '16px',
                            padding: '2.5rem',
                            boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
                        }}>
                            {/* Google Sign In */}
                            <button
                                type="button"
                                onClick={() => window.location.href = '/auth/google'}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    backgroundColor: '#ffffff',
                                    color: '#1a1a2e',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '10px',
                                    fontWeight: '500',
                                    fontSize: '1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.borderColor = '#6366f1';
                                    e.target.style.background = 'rgba(99, 102, 241, 0.02)';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.borderColor = '#e2e8f0';
                                    e.target.style.background = '#ffffff';
                                }}
                            >
                                <img
                                    src="https://developers.google.com/identity/images/g-logo.png"
                                    alt="Google logo"
                                    style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                />
                                Sign in with Google
                            </button>

                            {/* Divider */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '1.5rem 0'
                            }}>
                                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #e2e8f0' }} />
                                <span style={{ margin: '0 1rem', color: '#94a3b8', fontSize: '0.875rem' }}>or continue with email</span>
                                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #e2e8f0' }} />
                            </div>

                            {/* Email Form */}
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={inputStyle}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#6366f1';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e2e8f0';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s, box-shadow 0.2s'
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 8px 24px rgba(99, 102, 241, 0.4)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    Send Login Code
                                </button>
                                {status && (
                                    <p style={{
                                        marginTop: '1rem',
                                        color: status.includes('wrong') ? '#ef4444' : '#64748b',
                                        textAlign: 'center',
                                        fontSize: '0.9rem'
                                    }}>
                                        {status}
                                    </p>
                                )}
                            </form>

                            <p style={{
                                marginTop: '1.5rem',
                                textAlign: 'center',
                                color: '#94a3b8',
                                fontSize: '0.8rem'
                            }}>
                                We'll send you a 6-digit code to sign in.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default LoginDesktop;
